const hyperlinkPropsFunc = (record, column) => {
	return {
		labelText: record[column.columnName]
	};
};

const hyperlinkEventsFunc = (record, column, dynamicComponentEventHandler) => {
	return {
		click: () => {
			dynamicComponentEventHandler('opCodeModelClick', record);
		}
	};
};

const hyperlinkComponentDef = {
	name: 'Hyperlink',
	props: hyperlinkPropsFunc,
	events: hyperlinkEventsFunc
};

export default [
	{
		columnName: 'id',
		columnDisplayName: 'OpCode Id',
		display: false
	},
	{
		columnName: 'opCode',
		columnDisplayName: 'Op Codes',
		columnModifierName: 'opcode',
		display: true,
		isSortable: true,
		sortDirection: 'ASC',
		component: hyperlinkComponentDef
	},
	{
		columnName: 'description',
		columnDisplayName: 'Description',
		columnModifierName: 'description',
		display: true,
		isSortable: false
	}
];
